import { useEffect, useState, type ReactElement } from 'react';
import { StoreBadge, newHandoffId, type Store } from '../../../../../shared-web/StoreBadges';
import { getOs } from '../../../../../shared-web/ua-detect';
import { isStandaloneDisplay } from '../../../../../shared-web/install-guide.js';

/**
 * The app button on the homepage's first screen (2026-10-26 Riley): the store's own badge under the nav's right end,
 * its right edge on the avatar's — for a person without the app (`hasApp` false: the homepage's per-person read
 * says so; a visitor is not known and sees it). A phone gets its own store, a computer both. Not inside the Ember
 * app's webview or an installed PWA. Hidden once the nav docks over the page (TreeHome.css).
 */
export function NavAppBadge({ hasApp }: { hasApp: boolean | null }): ReactElement | null {
  const [store, setStore] = useState<Store | 'both' | null>(null);
  const [handoffId, setHandoffId] = useState('');
  useEffect(() => {
    if (hasApp !== false) { setStore(null); return; }
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    if (/EmberApp/i.test(ua) || isStandaloneDisplay(window)) return;
    const os = getOs();
    const next: Store | 'both' = os === 'ios' || os === 'android' ? os : 'both';
    if (next !== 'ios') setHandoffId(newHandoffId());
    setStore(next);
  }, [hasApp]);
  if (!store) return null;
  return (
    <div className="nav-app-badge" data-log-seen="app_store_badge" data-log-discovery="nav" data-log-state={store}>
      {store !== 'android' ? <StoreBadge store="ios" discovery="nav" size="sm" /> : null}
      {store !== 'ios' ? <StoreBadge store="android" discovery="nav" handoffId={handoffId} size="sm" /> : null}
    </div>
  );
}
